import axiosPost from "./axiosPost";

export const RNHTituloIns = async (credentials, data) => {
    const body = {
        service: "RNHTituloIns",
        params: {
            rnhTituloCod: data?.cod || null,
            rnhTituloNombre: data?.name || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
